import { render, staticRenderFns } from "./EnabledDisabledItem.vue?vue&type=template&id=0fdb996e&scoped=true&"
import script from "./EnabledDisabledItem.vue?vue&type=script&lang=ts&"
export * from "./EnabledDisabledItem.vue?vue&type=script&lang=ts&"
import style0 from "./EnabledDisabledItem.vue?vue&type=style&index=0&id=0fdb996e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb996e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VImg,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
